'use client';

import React from 'react';
import ApolloWrapper from './ApolloWrapper';
import Footer from '@/components/common/Footer';
import Header from '@/components/common/Header';
import ThemeTransition from './PageTransition';

// === Types ===
type RichTextChild = {
  type: 'text' | 'link';
  text?: string;
  url?: string;
  children?: { text: string }[];
};

type RichTextBlock = {
  children: RichTextChild[];
};

type Header = {
  enquire_menu_label: string;
  enquire_menu_link: string; // ✅ Add this line
  menu: {
    name: string;
    link: string;
    image?: { url: string; alternativeText?: string };
  }[];
  left_side_text: string;
  site_details: { children?: { text: string }[] }[];
};

type FooterData = {
  top_left_side_text: string;
  menu: { name: string; link: string }[];
  terms_and_conditions_link: string;
  terms_and_conditions_text: string;
  site_by_text: string;
  join_the_newsletter_text: string;
  about_tbc: {
    title: string;
    description: RichTextBlock[]; // ✅ Fixed here
    address: string;
  };
};

type Global = {
  site_name: string;
  site_description: string;
  site_favicon?: { url: string };
  header: Header;
  footer: FooterData;
};

export default function LayoutClient({
  children,
  globalData,
}: {
  children: React.ReactNode;
  globalData: Global;
}) {
  return (
    <ApolloWrapper>
      <ThemeTransition>
        <Header globalData={globalData} />
        <main className="flex-grow body-content">{children}</main>
        <Footer globalData={globalData} />
      </ThemeTransition>
    </ApolloWrapper>
  );
}
